import { render, staticRenderFns } from "./ProviderAuthRedirect.vue?vue&type=template&id=aff7b260&scoped=true&"
import script from "./ProviderAuthRedirect.vue?vue&type=script&lang=js&"
export * from "./ProviderAuthRedirect.vue?vue&type=script&lang=js&"
import style0 from "./ProviderAuthRedirect.vue?vue&type=style&index=0&id=aff7b260&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff7b260",
  null
  
)

export default component.exports